import { ChevronDown, ChevronUp, Trash2 } from "lucide-react"
import CommentReply from "./CommentReply"
import { useState } from "react"

const Comment = ({ comment, replies, onDeleteComment }) => {
    const [showReplies, setShowReplies] = useState(false)

    const commentReplies = replies.filter(r => r.parentCommentId === comment._id)

    return (
        <div className="mb-6">
            <div className="flex justify-between">
                <div className="flex gap-3">
                    <img
                        src={comment.user?.profileImage || `https://ui-avatars.com/api/?name=${comment.user?.fullName}&background=random`}
                        alt={comment.user?.fullName}
                        className="w-8 h-8 rounded-full flex-shrink-0 mt-5"
                    />
                    <div className="flex-1">
                        <div className="bg-gray-50 rounded-2xl px-4 py-3">
                            <div className="flex items-center justify-between mb-1">
                                <div className="flex items-center gap-2">
                                    <span className="font-semibold text-sm text-gray-900">{comment.user?.fullName}</span>
                                    {comment.user?.isExpert && (
                                        <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">Expert</span>
                                    )}
                                    <span className="text-xs text-gray-500">
                                        {new Date(comment.createdAt).toLocaleDateString()}
                                    </span>
                                </div>
                            </div>
                            <p className="text-sm text-gray-700">{comment.text}</p>
                        </div>
                        <div className="flex items-center gap-4 mt-2 ml-4">

                            <span className="text-xs text-gray-500">{comment.totalLikes} likes</span>
                            {commentReplies.length > 0 && (
                                <button
                                    onClick={() => setShowReplies(!showReplies)}
                                    className="flex items-center gap-1 text-xs font-medium text-blue-600 hover:text-blue-700"
                                >
                                    {showReplies ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
                                    {commentReplies.length} {commentReplies.length === 1 ? 'reply' : 'replies'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                <Trash2 className="text-red-500 mx-4 mt-2 cursor-pointer h-5 w-5" onClick={() => onDeleteComment(comment._id)} />
            </div>

            {showReplies && commentReplies.length > 0 && (
                <div className="mt-4">
                    {commentReplies.map((reply) => (
                        <CommentReply key={reply._id} reply={reply} onDeleteComment={onDeleteComment} />
                    ))}
                </div>
            )}
        </div>
    )
}

export default Comment
